import { render } from "./ChooseForm.vue?vue&type=template&id=5f7dbb18"
import script from "./ChooseForm.vue?vue&type=script&lang=js"
export * from "./ChooseForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__